// Single source of truth for the page content column so every top-level
// section — on every page — resizes with the same formula as the Header's
// nav bar. Before this existed, Header/Home/AboutUs/News/Pricing each
// hardcoded their own maxWidth (1200/1500/1100px) and even mixed centering
// strategies (maxWidth+% padding vs vw-based clamp()), so a section's left/
// right edge drifted relative to the header by a different amount on every
// page, and by a different amount again at every viewport width. Import
// PAGE_MAX_WIDTH (or spread pageContainerStyle) into any new top-level page
// section instead of inventing a new value — see pageLayoutConsistency.test.js.
export const PAGE_MAX_WIDTH = '1200px';

// data-layout attribute (not a CSS class, so it can't collide with a
// component's own styling class) marking every element that owns the page's
// outer horizontal alignment. pageLayoutConsistency.test.js queries this to
// assert every page's containers share the same rendered maxWidth.
export const PAGE_CONTAINER_MARK = 'page-container';

export const pageContainerStyle = {
  width: '100%',
  maxWidth: PAGE_MAX_WIDTH,
  margin: '0 auto',
  padding: '0 5%',
  boxSizing: 'border-box',
};
